var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',[_c('h1',[_vm._v("First Timer Welcome Gift")]),_c('h2',{staticClass:"mb-3"},[_vm._v("Ra Yoga Journals")]),_c('customer-journal-table')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }